import { useState, useCallback } from "react";
import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { BlockEditModal } from "../BlockEditModal";
import { sanitizeToHtml } from "@/components/preview/BlockRenderer";
import styles from "../blocks/blocks.module.scss";

export function FootnoteBlockNodeView({ node, updateAttributes, selected, deleteNode }: NodeViewProps) {
  const text = (node.attrs.text as string) || "";

  const [isOpen, setIsOpen] = useState(false);
  const [draftText, setDraftText] = useState(text);

  const handleOpen = useCallback(() => {
    setDraftText(text);
    setIsOpen(true);
  }, [text]);

  const handleSave = useCallback(() => {
    updateAttributes({ text: draftText });
    setIsOpen(false);
  }, [draftText, updateAttributes]);

  return (
    <NodeViewWrapper data-type="footnote-block-node" data-block-id={node.attrs.blockId} className={selected ? "ProseMirror-selectednode" : ""}>
      <div
        onClick={handleOpen}
        style={{ cursor: "pointer", padding: "8px 12px", borderLeft: "3px solid var(--lilia-border, #ddd)", fontSize: 13, color: "var(--lilia-text-muted, #666)" }}
      >
        <strong>Footnote:</strong>{" "}
        {text ? (
          <span dangerouslySetInnerHTML={{ __html: sanitizeToHtml(text) }} />
        ) : (
          <span style={{ fontStyle: "italic" }}>Click to add footnote text...</span>
        )}
      </div>

      <BlockEditModal
        sourceNode={node}
        title="Edit Footnote"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={handleSave}
        onDelete={() => { setIsOpen(false); deleteNode(); }}
        width={500}
      >
        <div>
          <label style={{ display: "block", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Footnote Text</label>
          <textarea
            value={draftText}
            onChange={(e) => setDraftText(e.target.value)}
            placeholder="Enter footnote text..."
            rows={4}
            autoFocus
            style={{
              width: "100%", padding: "12px", fontSize: 13,
              border: "1px solid var(--lilia-border, #ddd)", borderRadius: 4,
              resize: "vertical", lineHeight: 1.6,
            }}
          />
        </div>
      </BlockEditModal>
    </NodeViewWrapper>
  );
}
